import React, { useEffect, useState } from "react"; 
import { useLocation } from "react-router-dom";
import { useApproveChallengePost } from "../apis/knackchallenge";

const ChallengeApprovePost = () => {
    const search = useLocation().search;
    const ContentId = new URLSearchParams(search).get("ContentId");
    const [message, setMessage] = useState("Approving your post...");

    // useApproveChallengePost should provide mutateAsync (if not, check your API hook)
    const { mutateAsync } = useApproveChallengePost();

    const APICall = async () => {
        if (!ContentId) {
            console.error("Invalid ContentId");
            setMessage("Invalid request. No content ID provided.");
            return;
        }

        try {
            const response = await mutateAsync({ challengePostID: ContentId, status: 2 });
            // Assuming response has a 'message' field:
            if (response?.message === "Challenge post approved successfully") {
                setMessage("✅ Your post has been approved and will be posted on the scheduled date.");
            } else {
                console.error(response?.message || "Failed to approve post");
                setMessage(`❌ ${response?.message || response?.error || "Failed to approve post"}`);
            }
        } catch (error) {
            console.error("Error:", error);
            const errorData = error.response?.data;
            if (errorData?.errorType === 'image_validation' || errorData?.errorType === 'image_required') {
                setMessage(`❌ Image Validation Failed: ${errorData.message || 'Image does not meet Instagram requirements'}`);
            } else {
                const errorMessage = errorData?.message || 
                                    errorData?.error || 
                                    error.message || 
                                    "An error occurred while approving your post.";
                setMessage(`❌ ${errorMessage}`);
            }
        }
    };

    useEffect(() => {
        APICall();
    }, []);

    return (
        <div className="container d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
            <div className="text-center">
                <h3>{message}</h3>
            </div>
        </div>
    );
};

export default ChallengeApprovePost;
